module.exports = __webpack_public_path__ + "img/sample.3bd3d6a5.gif";